import { Component, Input } from '@angular/core';
import { Column } from '../metro-table/metro-table.component';

@Component({
  selector: 'app-metro-table-skeleton',
  standalone: false,
  templateUrl: './metro-table-skeleton.component.html',
})
export class MetroTableSkeletonComponent {
  @Input() columns: Column[] = [];
  @Input() rows: number = 10;
  @Input() includeActions: boolean = true;

  get skeletonRows(): undefined[] {
    return Array.from({ length: Math.max(0, this.rows) });
  }
}
